import React from 'react';
import { Box, Typography } from '@mui/material';
import AdminDashboard from './AdminDashboard';
import DealerDashboard from './DealerDashboard';
import UserDashboard from './UserDashboard';

const Dashboard = ({ user, enquiries, dealers, onAssignDealer }) => {


  return (
    <Box>
      {user.isAdmin ? (
        <AdminDashboard 
          user={user} 
          enquiries={enquiries} 
          dealers={dealers}  // Add this line
          onAssignDealer={onAssignDealer} 
        />
      ) : user.isDealer ? (
        <DealerDashboard 
          user={user} 
          enquiries={enquiries} 
        />
      ) : (
        <UserDashboard 
  user={user} 
  enquiries={enquiries.filter(e => 
    (e.customerEmail && e.customerEmail.toLowerCase() === user.email.toLowerCase()) ||
    (e.email && e.email.toLowerCase() === user.email.toLowerCase())
  )} 
/>

      )}
    </Box>
  );
};

export default Dashboard;